import { WrapMain } from '../../../../shared/modules/wrap_main'
import { useLocation } from 'react-router-dom';
import { selectMainState, useSelector } from "src/stateManagement/redux";
import { BackupMobile } from 'src/tecnica/modules/backupMobile';

export const BackUpMobileFiles = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');

    const { configModules } = useSelector(selectMainState);
    

    return (
        <WrapMain>
            {id &&  <BackupMobile/>}           
        </WrapMain>
    )
}